var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.name,{tag:"component",attrs:{"periode_forme":_vm.periode_forme,"nbperiode":_vm.nbperiode,"cle":_vm.cle,"libperiode":_vm.libperiode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }